/**
 * Max characters allowed in an article's executive summary (the `excerpts`
 * field). The backend turns this text into a Google TTS audio clip; ~16
 * chars/sec means 400 characters keeps that clip under 30 seconds.
 */
export const EXEC_SUMMARY_MAX_CHARS = 400;

/** Visible character count of excerpt HTML (Quill markup tags stripped). */
export const getExcerptLength = (html: string): number =>
  html.replace(/<[^>]*>/g, "").length;
